import { SPACELIFT_VCS_REPOS_COLUMN_ID } from "../constants";
import SpaceliftVcsReposTableNameCell from "./NameCell";
import SpaceliftVcsReposTableDescriptionCell from "./DescriptionCell";
import SpaceliftVcsReposTableSpaceCell from "./SpaceCell";
import SpaceliftVcsReposTableCreatedAtCell from "./CreatedAtCell";
import SpaceliftVcsReposTableRowActionsCell from "./RowActionsCell";

export const SPACELIFT_VCS_REPOS_TABLE_CELLS = {
  [SPACELIFT_VCS_REPOS_COLUMN_ID.NAME]: SpaceliftVcsReposTableNameCell,
  [SPACELIFT_VCS_REPOS_COLUMN_ID.DESCRIPTION]: SpaceliftVcsReposTableDescriptionCell,
  [SPACELIFT_VCS_REPOS_COLUMN_ID.SPACE]: SpaceliftVcsReposTableSpaceCell,
  [SPACELIFT_VCS_REPOS_COLUMN_ID.CREATED_AT]: SpaceliftVcsReposTableCreatedAtCell,
  [SPACELIFT_VCS_REPOS_COLUMN_ID.DROPDOWN]: SpaceliftVcsReposTableRowActionsCell,
};
